import React, { useRef, useState } from 'react';
import AnimDesktop from '../../../assets/images/startseite-animation-desktop.gif';
import AnimMobil from '../../../assets/images/startseite-animation-mobil.gif';
import { IconPlayerPlay, IconPlayerPause } from '@tabler/icons-react';

const PausableGif = ({ gifSrc, alt }) => {
    const [isPlaying, setIsPlaying] = useState(true);
    const imgRef = useRef(null);
    const canvasRef = useRef(null);

    const togglePlayPause = () => {
        if (isPlaying) {
            const img = imgRef.current;
            const canvas = canvasRef.current;
            if (img && canvas) {
                const ctx = canvas.getContext('2d');
                canvas.width = img.naturalWidth || img.clientWidth || 300;
                canvas.height = img.naturalHeight || img.clientHeight || 200;
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            }
            setIsPlaying(false);
        } else {
            setIsPlaying(true);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            togglePlayPause();
        }
    };

    return (
        <div
            className="position-relative w-100 overflow-hidden rounded mb-3"
            style={{ cursor: 'pointer' }}
            onClick={togglePlayPause}
            onKeyDown={handleKeyDown}
            tabIndex={0}
            role="button"
            aria-label={isPlaying ? 'Animation pausieren' : 'Animation abspielen'}
        >
            <img
                ref={imgRef}
                src={gifSrc}
                alt={alt}
                style={{ width: '100%', height: 'auto', display: isPlaying ? 'block' : 'none' }}
            />
            <canvas ref={canvasRef} style={{ width: '100%', height: 'auto', display: !isPlaying ? 'block' : 'none' }} />
            <div
                className="position-absolute d-flex align-items-center justify-content-center"
                style={{
                    bottom: '12px',
                    right: '12px',
                    width: '38px',
                    height: '38px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(21, 37, 54, 0.7)',
                    color: '#ffffff',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    transition: 'all 0.2s ease-in-out',
                    zIndex: 10,
                }}
                title={isPlaying ? 'Animation pausieren' : 'Animation abspielen'}
            >
                {isPlaying ? <IconPlayerPause size={18} /> : <IconPlayerPlay size={18} />}
            </div>
        </div>
    );
};

const CampaignFlow = () => {
    return (
        <div className="w-100">
            {/* Desktop-only Startseite Animation */}
            <div className="d-none d-lg-block w-100">
                <PausableGif gifSrc={AnimDesktop} alt="Ablauf der Kampagne (Desktop)" />
            </div>

            {/* Mobile-only Startseite Animation */}
            <div className="d-block d-lg-none w-100">
                <PausableGif gifSrc={AnimMobil} alt="Ablauf der Kampagne (Mobil)" />
            </div>
        </div>
    );
};

export default CampaignFlow;
